<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="AddWorkLvMoney" :model="formData" :rules="rules" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="类型" prop="PaWorkLvMoney.type">
            <el-select class="input-item" v-model="formData.PaWorkLvMoney.type" :clearable="true" filterable :disabled="true"
              placeholder="类型" :loading="AddWorkLvMoney.type.impl.loading"
              @visible-change="AddWorkLvMoney.type.impl.onVisibleChange"
              @change="onTypeValueChange">
              <el-option v-for="item in AddWorkLvMoney.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="名称" prop="PaWorkLvMoney.name">
            <el-input class="input-item" v-model="formData.PaWorkLvMoney.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showlvMin">
          <el-form-item :label="labellvMin" prop="PaWorkLvMoney.lvMin">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.lvMin" :clearable="true" :placeholder="labellvMin" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showlvMax">
          <el-form-item :label="labellvMax" prop="PaWorkLvMoney.lvMax">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.lvMax" :clearable="true" :placeholder="labellvMax" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showmoney">
          <el-form-item :label="labelmoney" prop="PaWorkLvMoney.money">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.money" :clearable="true" :placeholder="labelmoney" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvD">
          <el-form-item :label="labelLvD" prop="PaWorkLvMoney.lvD">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.lvD" :clearable="true" :placeholder="labelLvD" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvMoney.type!=='root'">
          <el-form-item label="启用" prop="PaWorkLvMoney.enableFlag">
            <el-radio-group class="input-item" v-model="formData.PaWorkLvMoney.enableFlag" @change="onEnableFlagValueChange">
              <el-radio v-for="item in AddWorkLvMoney.enableFlag.impl.dropdownList" :key="item.id" :label="item.id">
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvMoney.type!=='root'">
          <el-form-item label="排序" prop="PaWorkLvMoney.sort">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.sort"
                             :clearable="true"
                             placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaWorkLvMoney.detail">
            <el-input class="input-item" v-model="formData.PaWorkLvMoney.detail"
              :clearable="true" placeholder="描述" type="textarea" :autosize="{ minRows: 4}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaWorkLvMoney.remark">
            <el-input class="input-item" v-model="formData.PaWorkLvMoney.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaWorkLvMoneyController, DictionaryController } from '@/api';

export default {
  name: 'AddWorkLvMoney',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    pid: {
      default: undefined
    },
    type: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      showlvMin: false,
      showlvMax: false,
      showmoney: false,
      showLvD: false,
      labellvMin: '比例区间最低',
      labellvMax: '比例区间最高',
      labelmoney: '奖励金额',
      labelLvD: 'D级',
      formData: {
        PaWorkLvMoney: {
          id: undefined,
          pid: this.pid,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: this.type,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: 'Y',
          sort: 1,
          lvMin: 0,
          lvMax: 0,
          money: 0,
          lvD: 0,
          lvE: 0,
          lvF: 0,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'PaWorkLvMoney.name': [{required: true, message: '请输入名称', trigger: 'blur'}],
        'PaWorkLvMoney.lvMin': [{required: true, message: '请输入区间最低', trigger: 'blur'}],
        'PaWorkLvMoney.lvMax': [{required: true, message: '请输入区间最高', trigger: 'blur'}],
        'PaWorkLvMoney.money': [{required: true, message: '请输入奖励金额', trigger: 'blur'}],
        'PaWorkLvMoney.lvD': [{required: true, message: '请输入D级', trigger: 'blur'}]
      },
      AddWorkLvMoney: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        enableFlag: {
          impl: new DropdownWidget(this.loadEnableFlagDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_lv_Money_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 启用下拉数据获取函数
     */
    loadEnableFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 启用选中值改变
     */
    onEnableFlagValueChange (value) {
    },
    /**
     * 更新添加作品级别分值
     */
    refreshAddWorkLvMoney (reloadData = false) {
      // let x = this.type === 'type' ? '(分)' : '(%)';
      this.labellvMin = this.labellvMin + '(%)';
      this.labellvMax = this.labellvMax + '(%)';
      this.labelmoney = this.labelmoney + '(元)';
      // this.labelLvD = this.labelLvD + x;
      console.log('>>>>>>>>>>>>', this.type);

      this.showlvMin = this.showlvMax = this.showmoney = this.showLvD = false;
      if (this.type === 'root') {
        this.formData.PaWorkLvMoney.type = 'big_type';
      } else if (this.type === 'big_type') {
        this.formData.PaWorkLvMoney.type = 'type';
      } else if (this.type === 'type') {
        this.showlvMin = true;
        this.showlvMax = true;
        this.showmoney = true;
        this.formData.PaWorkLvMoney.type = 'post';
      } else if (this.type === 'post') {
        // PaWorkLvMoneyController.view(this, {id: this.pid}).then(pres => {
        //   // let parentItem = {...pres.data};
        //
        // });
      }
      if (!this.AddWorkLvMoney.isInit) {
        // 初始化下拉数据
        this.AddWorkLvMoney.enableFlag.impl.onVisibleChange(true).catch(e => {});
        this.AddWorkLvMoney.type.impl.onVisibleChange(true).catch(e => {});
      }
      this.AddWorkLvMoney.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.AddWorkLvMoney.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            typeDictMap: findItemFromList(this.AddWorkLvMoney.type.impl.dropdownList, this.formData.PaWorkLvMoney.type, 'id'),
            enableFlagDictMap: findItemFromList(this.AddWorkLvMoney.enableFlag.impl.dropdownList, this.formData.PaWorkLvMoney.enableFlag, 'id'),
            ...this.formData.PaWorkLvMoney
          };
          this.onCancel(true, formData);
          return;
        }
        // let paWorkLvMoney = this.formData.PaWorkLvMoney;
        let params = {
          paWorkLvMoneyDto: {
            pid: this.pid,
            tid: this.formData.PaWorkLvMoney.tid,
            tname: this.formData.PaWorkLvMoney.tname,
            gcode: this.formData.PaWorkLvMoney.gcode,
            code: this.formData.PaWorkLvMoney.code,
            type: this.formData.PaWorkLvMoney.type,
            name: this.formData.PaWorkLvMoney.name,
            detail: this.formData.PaWorkLvMoney.detail,
            remark: this.formData.PaWorkLvMoney.remark,
            deptPostId: this.formData.PaWorkLvMoney.deptPostId,
            lvMin: this.formData.PaWorkLvMoney.lvMin,
            lvMax: this.formData.PaWorkLvMoney.lvMax,
            money: this.formData.PaWorkLvMoney.money,
            lvD: this.formData.PaWorkLvMoney.lvD,
            lvE: this.formData.PaWorkLvMoney.lvE,
            lvF: this.formData.PaWorkLvMoney.lvF,
            sort: this.formData.PaWorkLvMoney.sort,
            enableFlag: this.formData.PaWorkLvMoney.enableFlag
          }
        };

        PaWorkLvMoneyController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaWorkLvMoney: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: undefined,
          sort: undefined,
          lvMin: undefined,
          lvMax: undefined,
          money: undefined,
          lvD: undefined,
          lvE: undefined,
          lvF: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAddWorkLvMoney();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaWorkLvMoney = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
